import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    dialogContent: {
        width: '300px',
        padding: '12px 24px',
        borderBottom: '2px solid #f0f0f0'
    },
    textField: {
        marginTop: '12px'
    },
    createBtn: {
        width: '160px',
        margin: '20px auto'
    }
}))

export default useStyles